import styled from "styled-components"
import { displays } from "theme/base/Variables"
import { LinkIconStyled } from "theme/common/Link.styled"

export const CardItemStyled = styled(LinkIconStyled)`
  ${displays.flexBase}
  border-radius: 7px;
`
